import React from 'react';
import infoIcon from '@amzn/meridian-tokens/base/icon/alert-warning-small';
import Tooltip from '@amzn/meridian/tooltip';
import Icon from '@amzn/meridian/icon';
import { useIntl } from 'react-intl';
import { TooltipPositionsEnum } from '../../constants/meridian';

const InfoComponent = ({ disabled, messageId, position = TooltipPositionsEnum.end }) => {
  const { formatMessage } = useIntl();
  if (disabled) return null;
  return (
    <Tooltip position={position} title={formatMessage({ id: messageId })}>
      <Icon tokens={infoIcon} />
    </Tooltip>
  );
};

export default InfoComponent;
